import React, { useState } from 'react';
import DENTModalOverviewGeneralEndodonticButtons from './DENTModalOverviewGeneralEndodonticButtons';
import { ToothEndodontic } from '../../../../graphql/graphql';
import { EndodonticButtonOption } from '../../Helpers/endodontic/endodonticButtonOptions';
import DENTModalOverviewGeneralEndodonticPainButtons from './DENTModalOverviewGeneralEndodonticPainButtons';

interface Props {
	type: Extract<EndodonticButtonOption['value'], 'percussion' | 'palpation'>;
	onClose: () => void;
}

export const DENTModalOverviewGeneralEndodonticTest = ({
	type,
	onClose,
}: Props) => {
	const [value, setValue] = useState<ToothEndodontic[typeof type]>();

	return (
		<DENTModalOverviewGeneralEndodonticButtons
			type={type}
			values={value}
			onClose={onClose}>
			<DENTModalOverviewGeneralEndodonticPainButtons
				value={value}
				onChange={setValue}
			/>
		</DENTModalOverviewGeneralEndodonticButtons>
	);
};

export default DENTModalOverviewGeneralEndodonticTest;
